import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

const statusDescriptions = {
  '404': 'Resource not found',
  '400': 'Invalid request',
  '401': 'Unauthorized',
  '403': 'Forbidden',
  '500': 'Internal server error'
};

@Injectable({
  providedIn: 'root'
})
export class ErrorService {

  constructor(private toastr: ToastrService) {

  }

  errorMessage(): string {    
    return "Unfortunately, there is an error occurred. Please attach the screenshot of the page and send an email to accesshub@abbvie.com with details for further assistance.";
  }

  async show(title: string, error: any) {
    console.error( '%s: %o', title, error);
    let message;
    if (error && error.response) {
      try {
        const result = await error.response.json();
        message = result['odata.error'].message.value;
        console.log(result);
      }
      catch (err) {
        console.warn(err);
      }
    }
    if (!message && error?.message?.value) {
      message = error.message.value;
    }
    if (!message && error.status) {
      message = statusDescriptions[error.status];
    }
    if (!message ) {
      message = error.message;
    }
    if (!message) {
      message = 'Unexpected error';
    }
    this.toastr.error(message, title, {
      timeOut: 20000
    });
  }
}
